// ドロワーナビゲーションアイテム
export const navItems = [
  { icon: "mdi-ferry", title: "Home", value: "home", to: "/" },
  { icon: "mdi-message", title: "Message", value: "message", to: "/message" },
  { icon: "mdi-domain", title: "Company", value: "company", to: "/company" },
  {
    icon: "mdi-view-list-outline",
    title: "Projects",
    value: "projects",
    to: "/projects",
  },
  { icon: "mdi-post-outline", title: "Blog", value: "blog", to: "/blog" },
  { icon: "mdi-forum", title: "Contact", value: "contact", to: "/contact" },
];
